import {
  Box,
  Grid,
  createTheme,
  ThemeProvider,
  Menu,
  Stack,
  Select,
  TextField,
  InputAdornment,
  Button,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";

import React, { useEffect, useState } from "react";
import { format } from "date-fns";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import MenuItem from "@mui/material/MenuItem";
import MUIDataTable from "mui-datatables";
import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { useNavigate } from "react-router-dom";
import config from "../../Data/AuthUser";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function FleetVehicles() {
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [openMenuId, setOpenMenuId] = useState(null);
  const [fleetData, setFleetData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterOpen, setFilterOpen] = useState(false);
  const navigate = useNavigate();

  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    try {
      // Replace with your actual API call
      // const response = await fleetVehicleApis.getAll();
      // console.log(response, "response got");
      // setFleetData(response?.data);
      
      // Mock data for demonstration
      setFleetData([
        {
          id: 1,
          truck_type: "Heavy Duty",
          owner: {
            id: "OWN001",
            name: "John Smith",
            image: "default-profile.jpg"
          },
          number_of_trucks: 5
        },
        {
          id: 2,
          truck_type: "Medium Duty",
          owner: {
            id: "OWN002",
            name: "Sarah Johnson",
            image: "default-profile.jpg"
          },
          number_of_trucks: 8
        },
        {
          id: 3,
          truck_type: "Light Duty",
          owner: {
            id: "OWN003",
            name: "Robert Wilson",
            image: "default-profile.jpg"
          },
          number_of_trucks: 12
        }
      ]);
    } catch (error) {
      console.error("Error fetching fleet vehicles:", error);
      showAlert("Failed to load fleet vehicles", "error");
    }
  }

  const handleOpenMenu = (id) => {
    setOpenMenuId(id);
  };

  const handleViewMore = async () => {
    try {
      // Replace with your actual API call
      // const rowData = await fleetVehicleApis.viewMoreById(openMenuId);
      navigate(`/fleet/vehicles/${openMenuId}`, { state: { id: openMenuId } });
    } catch (error) {
      console.error("Error viewing vehicle details:", error);
      showAlert("Failed to load vehicle details", "error");
    }
  };

  const handleEditVehicle = () => {
    navigate(`/fleet/vehicles/edit/${openMenuId}`);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openDropMenu = Boolean(anchorEl);
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const HeaderFleetVehicles = () => {
    const [dateDropdownOpen, setDateDropdownOpen] = useState(false);
      const handleFiltersOpen = () => {
    console.log("Filters button clicked");
  };
    return (
  //     <Box mb={2} sx={{ backgroundColor: "white", padding: "20px", borderRadius: "4px" }}>
  //       <Grid container spacing={2} alignItems="center">
  //         <Grid item xs={12} sm={6} md={4}>
  //           <TextField
  //             variant="outlined"
  //             fullWidth
  //             placeholder="Search fleet vehicles..."
  //             value={searchTerm}
  //             onChange={(e) => setSearchTerm(e.target.value)}
  //             InputProps={{
  //               startAdornment: (
  //                 <InputAdornment position="start">
  //                   <SearchIcon color="primary" />
  //                 </InputAdornment>
  //               ),
  //               style: { color: "black", backgroundColor: "white" }
  //             }}
  //             sx={{
  //               '& .MuiOutlinedInput-root': {
  //                 '& fieldset': {
  //                   borderColor: '#e0e0e0',
  //                 },
  //                 '&:hover fieldset': {
  //                   borderColor: 'primary.main',
  //                 },
  //                 '&.Mui-focused fieldset': {
  //                   borderColor: 'primary.main',
  //                 },
  //               },
  //             }}
  //           />
  //         </Grid>
  //         <Grid item xs={12} sm={6} md={8} sx={{ display: "flex", justifyContent: { xs: "flex-start", md: "flex-end" } }}>
  //           <Button
  //             variant="outlined"
  //             color="primary"
  //             startIcon={<FilterListIcon />}
  //             onClick={() => setFilterOpen(!filterOpen)}
  //             sx={{ marginRight: 2 }}
  //           >
  //             Filters
  //           </Button>
  //           {/* <Button
  //             variant="contained"
  //             color="primary"
  //             onClick={() => navigate("/fleet/vehicles/add")}
  //           >
  //             Add New Vehicle
  //           </Button> */}
  //         </Grid>
  //         {filterOpen && (
  //           <Grid item xs={12}>
  //             <Box sx={{ backgroundColor: "#f5f5f5", padding: 2, borderRadius: 1, mt: 2 }}>
  //               <Grid container spacing={2}>
  //                 <Grid item xs={12} sm={6} md={3}>
  //                   <TextField 
  //                     select
  //                     fullWidth
  //                     label="Truck Type"
  //                     variant="outlined"
  //                     InputLabelProps={{ style: { color: 'black' } }}
  //                     sx={{ backgroundColor: "white" }}
  //                   >
  //                     <MenuItem value="Heavy Duty">Heavy Duty</MenuItem>
  //                     <MenuItem value="Medium Duty">Medium Duty</MenuItem>
  //                     <MenuItem value="Light Duty">Light Duty</MenuItem>
  //                   </TextField>
  //                 </Grid>
  //                 <Grid item xs={12} sm={6} md={3}>
  //                   <TextField 
  //                     select
  //                     fullWidth
  //                     label="Owner"
  //                     variant="outlined"
  //                     InputLabelProps={{ style: { color: 'black' } }}
  //                     sx={{ backgroundColor: "white" }}
  //                   >
  //                     <MenuItem value="all">All Owners</MenuItem>
  //                     {/* Dynamic list of owners would go here */}
  //                   </TextField>
  //                 </Grid>
  //                 <Grid item xs={12} sm={6} md={3}>
  //                   <TextField 
  //                     select
  //                     fullWidth
  //                     label="Sort By"
  //                     variant="outlined"
  //                     InputLabelProps={{ style: { color: 'black' } }}
  //                     sx={{ backgroundColor: "white" }}
  //                   >
  //                     <MenuItem value="newest">Newest First</MenuItem>
  //                     <MenuItem value="oldest">Oldest First</MenuItem>
  //                     <MenuItem value="trucks">Number of Trucks</MenuItem>
  //                   </TextField>
  //                 </Grid>
  //                 <Grid item xs={12} sm={6} md={3} sx={{ display: "flex", alignItems: "center" }}>
  //                   <Button variant="contained" color="primary" sx={{ mr: 1 }}>
  //                     Apply
  //                   </Button>
  //                   <Button variant="outlined" color="primary" onClick={() => setFilterOpen(false)}>
  //                     Reset
  //                   </Button>
  //                 </Grid>
  //               </Grid>
  //             </Box>
  //           </Grid>
  //         )}
  //       </Grid>
  //     </Box>
  //   );
  // };
  <div className="w-full bg-white shadow-sm mb-6 border-b border-gray-200">
        <div className="container mx-auto py-3 px-4">
          <div className="flex items-center gap-x-3">
            {/* Duration dropdown */}
            <div className="relative">
              <div className="flex items-center text-gray-600 text-sm font-normal hover:text-gray-800 focus:outline-none">
                <span>Duration</span>
              </div>
              <div className="absolute hidden bg-white shadow-md rounded-md mt-2 w-48 py-1 z-10">
                {/* Dropdown content would go here */}
              </div>
            </div>

            {/* Date range section */}
            <div className="flex items-center relative">
              <button
                className="text-gray-400 text-sm font-medium flex items-center"
                onClick={(e) => {
                  e.stopPropagation();
                  setDateDropdownOpen(!dateDropdownOpen);
                }}
              >
                Start Date To End Date
                <svg
                  className="w-4 h-4 ml-1"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>

              {dateDropdownOpen && (
                <div
                  className="absolute left-0 top-full mt-1 w-44 bg-white shadow-lg z-10 border border-gray-200"
                  style={{ boxShadow: "0 2px 10px rgba(0,0,0,0.1)" }}
                >
                  <div className="py-1">
                    <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Today
                    </button>
                    <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Last 30 Days
                    </button>
                    <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      This Month
                    </button>
                    <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Last Month
                    </button>
                    <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Last 90 Days
                    </button>
                    <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Last 6 Months
                    </button>
                    <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      Last 1 Year
                    </button>
                    <button className="w-full text-left px-4 py-2 text-sm text-gray-700 bg-gray-200">
                      Custom Range
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* Vertical divider - taller to override padding */}
            <div className="h-8 w-px bg-gray-300 my-auto ml-5"></div>

            {/* Recruiter section with dropdown */}
            <div className="flex items-center">
              <span className="text-gray-600 text-sm font-medium mr-2">
                Recruiter
              </span>
              <div className="inline-block relative">
                <div className="flex items-center bg-white border border-gray-300 rounded py-1 px-2 text-sm">
                  <select className="w-full border-none text-gray-900 appearance-none bg-white focus:outline-none">
                    <option>All</option>
                    <option>Opt1</option>
                  </select>
                  <svg
                    className="w-4 h-4 ml-1"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>
            </div>

            {/* Vertical divider - taller to override padding */}
            <div className="h-8 w-px bg-gray-300 my-auto"></div>

            {/* Search input */}
            <div className="relative">
              <div className="flex items-center border border-gray-300 rounded bg-gray-200">
                <div className="pl-2 pr-2">
                  <svg
                    className="w-4 h-4 text-gray-500"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <input
                  type="text"
                  placeholder="Start typing to search"
                  className="py-1 px-2 text-sm w-72 border-none rounded-none text-black focus:outline-none"
                />
              </div>
            </div>

            {/* <div className="h-8 w-px bg-gray-300 my-auto"></div> */}

            {/* Vertical divider - before filters */}
            {/* <div className="h-8 w-px bg-gray-300 my-auto ml-auto mr-2"></div> */}

            {/* Filters button */}
            <div className="ml-auto">
              <button
                className="flex items-center text-gray-600 hover:text-gray-800"
                onClick={handleFiltersOpen}
              >
                <svg
                  className="w-4 h-4 mr-1"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z"
                    clipRule="evenodd"
                  />
                </svg>
                <span className="text-sm font-medium">Filters</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const columns = [
    {
      name: "truck_type",
      label: "Truck Type",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
                color: "black",
                backgroundColor: "white"
              }}
            >
              Truck Type
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div style={{ textAlign: "center" }}>
              {value}
            </div>
          );
        }
      },
    },
    {
      name: "owner",
      label: "Owner Details",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
                color: "black",
                backgroundColor: "white"
              }}
            >
              Owner Details
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => {
          const ownerId = tableMeta.rowData[1]?.id;

          if (!value) {
            return <div>No owner data</div>;
          }

          const imageUrl = `${config.apiImageUrl}${value.image}`;
          
          return (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
              <img
                src={imageUrl}
                alt={value.name}
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  marginRight: "10px",
                }}
                // onError={(e) => {
                //   e.target.src = "/assets/default-avatar.png"; // Fallback image
                // }}
              />
              <div>
                <div style={{ fontWeight: "bold" }}>{value.name}</div>
                <div style={{ color: "gray", fontSize: "12px" }}>ID: {value.id}</div>
              </div>
            </div>
          );
        },
      },
    },
    {
      name: "number_of_trucks",
      label: "No of Trucks",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
                color: "black",
                backgroundColor: "white"
              }}
            >
              No of Trucks
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div style={{ textAlign: "center" }}>
              {value}
            </div>
          );
        },
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
                color: "black",
                backgroundColor: "white"
              }}
            >
              Action
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={openDropMenu ? "long-menu" : undefined}
                aria-expanded={openDropMenu ? "true" : undefined}
                aria-haspopup="true"
                onClick={(event) => {
                  handleOpenMenu(value);
                  handleClick(event);
                }}
                sx={{color: 'black'}}
              >
                <MoreHorizTwoToneIcon />
              </IconButton>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={openDropMenu && openMenuId === value}
                onClose={handleCloseMenu}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <MenuItem
                  onClick={() => {
                    handleViewMore();
                    handleCloseMenu();
                  }}
                >
                  <RemoveRedEyeIcon fontSize="small" color="primary" />
                  <Typography variant="body2" sx={{ ml: 1 }}>
                    View More
                  </Typography>
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleEditVehicle();
                    handleCloseMenu();
                  }}
                >
                  <EditNoteIcon fontSize="small" color="primary" />
                  <Typography variant="body2" sx={{ ml: 1 }}>
                    Edit
                  </Typography>
                </MenuItem>
              </Menu>
            </div>
          );
        },
      },
    },
  ];

    const options = {
    filterType: "checkbox",
    responsive: "standard",
    download: false,
    print: false,
    filter: false,
    viewColumns: false,
    selectableRows: "none",
    elevation: 0,
    pagination: true,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50, 100],
    search: false, // This removes the search icon
    customToolbar: null, // This removes the Add New Vehicle button
    setTableProps: () => {
      return {
        style: {
          backgroundColor: 'white',
        },
      };
    },
    setRowProps: () => {
      return {
        style: { backgroundColor: 'white' }
      };
    },
    setHeaderProps: () => {
      return {
        style: {
          backgroundColor: 'white',
          color: 'black',
          fontWeight: 'bold'
        }
      };
    },
    setCellProps: () => {
      return {
        style: {
          color: 'black'
        }
      };
    },
    textLabels: {
      body: {
        noMatch: "No records found",
        toolTip: "Sort",
      },
      pagination: {
        next: "Next Page",
        previous: "Previous Page",
        rowsPerPage: "Rows per page:",
        displayRows: "of",
      },
    }
  };
  return (
    <Box p={2}>
        <HeaderFleetVehicles />
      
      <Box mb={3} sx={{
        '& .MuiTableCell-root': {color:'black'},
        '& .MuiTypography-root': {color:'black'},
        '& .MuiToolbar-root': {backgroundColor: 'white'},
        '& .MuiPaper-root': {backgroundColor: 'white'},
        '& .MUIDataTableHeadCell-data': {
          color: 'black',
          fontWeight: 'bold'
        },
        '& .MuiTableHead-root': {
          backgroundColor: 'white'
        },
        '& .MuiTableFooter-root': {
          backgroundColor: 'white'
        },
        '& .MuiTablePagination-root': {
          color: 'black',
          backgroundColor: 'white'
        },
        '& .MUIDataTableToolbar-titleText': {
          color: 'black',
          fontWeight: 'bold',
          fontSize: '1.25rem'
        }
      }}>
        <MUIDataTable
          title="Fleet Vehicles Management"
          data={fleetData}
          columns={columns}
          options={options}
        />
      </Box>
    </Box>
  );
}

export default FleetVehicles;